const Profile = {
  options: {
    data: {},
    customization: {
      items: {
        type: 'DraggableListProfile',
        order: 1,
        data: {},
      },
      dangerColor: {
        type: 'HexColor',
        order: 8,
      },
      itemColor: {
        type: 'HexColor',
        order: 9,
      },
      logoutIcon: {
        type: 'IconSelector',
        data: {
          defaultIcon:
            'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504660_a167aca9-0425-4762-965e-0d6f8c6d24ef.png',
        },
        order: 10,
      },
      deleteIcon: {
        type: 'IconSelector',
        data: {
          defaultIcon:
            'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504660_a167aca9-0425-4762-965e-0d6f8c6d24ef.png',
        },
        order: 11,
      },
    },
  },
  variants: [
    {
      id: 'Profile_1',
      name: 'Profile_1',
      type: 'Profile',
      data: {
        text: '',
        images: [],
      },
      customization: {
        textAlignment: 'left',
        textSize: '12px',
        textColor: '#7059ef',
        textStyle: 'normal',
        textWeight: '400',
        backgroundColor: '#F0EEFB',
        textLetterSpacing: '4px',
        dangerColor: '#ff275f',
        itemColor: '#000000',
        logoutIcon: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706004973755.png',
        deleteIcon: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710503140_fb7aba20-9c96-4656-9e06-cb9699f56939.png',
        items: [
          {
            id: '1',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706004697300.png',
            name: 'Hesap Ayarları',
            image: {},
            label: 'ACCOUNT_SETTINGS',
            pointTo: {
              pointTo: 'ProfileSettings',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
            visible: true,
          },
          {
            id: '2',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710503543_c410acf5-8d8a-4656-9347-85c184c99030.png',
            name: 'Adreslerim',
            image: {},
            label: 'ADDRESS',
            pointTo: {
              pointTo: 'ProfileAdress',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
            visible: true,
          },
          {
            id: '3',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005142103.png',
            name: 'Favorilerim',
            image: {},
            label: 'FAVORITES',
            pointTo: {
              pointTo: 'Favorite',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
            visible: true,
          },
          {
            id: '4',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710503824_25d36113-c2ff-4f9b-ae9f-db5c8e610671.png',
            name: 'Siparişler',
            image: {},
            label: 'ORDERS',
            pointTo: {
              pointTo: 'ProfileOrders',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
            visible: true,
          },
          {
            id: '5',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710503561_c45a5c68-934a-44c3-a080-91b85ad4878e.png',
            name: 'Dil',
            image: {},
            label: 'LANGUAGE',
            pointTo: {
              pointTo: 'ProfileLanguage',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
            visible: true,
          },
          {
            id: '6',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710503752_81b5748b-4da6-4316-94c1-bb31a21d4dd2.png',
            name: 'Sözleşmeler',
            image: {},
            label: 'POLICIES',
            pointTo: {
              pointTo: 'ProfilePrivacyPolicy',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
            visible: true,
          },
        ],
      },
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/profile_1.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'Profile_2',
      name: 'Profile_2',
      type: 'Profile',
      data: {
        text: '',
        images: [],
      },
      customization: {
        textAlignment: 'left',
        textSize: '12px',
        textColor: '#7059ef',
        textStyle: 'normal',
        textWeight: '400',
        backgroundColor: '#F0EEFB',
        textLetterSpacing: '4px',
        dangerColor: '#ff275f',
        itemColor: '#000000',
        logoutIcon: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706004973755.png',
        deleteIcon: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710503140_fb7aba20-9c96-4656-9e06-cb9699f56939.png',
        items: [
          {
            id: '1',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706004697300.png',
            name: 'Hesap Ayarları',
            image: {},
            label: 'ACCOUNT_SETTINGS',
            pointTo: {
              pointTo: 'ProfileSettings',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
            visible: true,
          },
          {
            id: '2',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710503543_c410acf5-8d8a-4656-9347-85c184c99030.png',
            name: 'Adreslerim',
            image: {},
            label: 'ADDRESS',
            pointTo: {
              pointTo: 'ProfileAdress',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
            visible: true,
          },
          {
            id: '3',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005142103.png',
            name: 'Favorilerim',
            image: {},
            label: 'FAVORITES',
            pointTo: {
              pointTo: 'Favorite',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
            visible: true,
          },
          {
            id: '4',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710503824_25d36113-c2ff-4f9b-ae9f-db5c8e610671.png',
            name: 'Siparişler',
            image: {},
            label: 'ORDERS',
            pointTo: {
              pointTo: 'ProfileOrders',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
            visible: true,
          },
          {
            id: '5',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710503561_c45a5c68-934a-44c3-a080-91b85ad4878e.png',
            name: 'Dil',
            image: {},
            label: 'LANGUAGE',
            pointTo: {
              pointTo: 'ProfileLanguage',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
            visible: true,
          },
          {
            id: '6',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710503752_81b5748b-4da6-4316-94c1-bb31a21d4dd2.png',
            name: 'Sözleşmeler',
            image: {},
            label: 'POLICIES',
            pointTo: {
              pointTo: 'ProfilePrivacyPolicy',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
            visible: true,
          },
        ],
      },
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/profile_1.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'Profile_3',
      name: 'Profile_3',
      type: 'Profile',
      data: {
        text: '',
        images: [],
      },
      customization: {
        textAlignment: 'left',
        textSize: '12px',
        textColor: '#7059ef',
        textStyle: 'normal',
        textWeight: '400',
        backgroundColor: '#F0EEFB',
        textLetterSpacing: '4px',
        dangerColor: '#ff275f',
        itemColor: '#000000',
        logoutIcon: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706004973755.png',
        deleteIcon: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710503140_fb7aba20-9c96-4656-9e06-cb9699f56939.png',
        items: [
          {
            id: '1',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706004697300.png',
            name: 'Hesap Ayarları',
            image: {},
            label: 'ACCOUNT_SETTINGS',
            pointTo: {
              pointTo: 'ProfileSettings',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
            visible: true,
          },
          {
            id: '2',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710503543_c410acf5-8d8a-4656-9347-85c184c99030.png',
            name: 'Adreslerim',
            image: {},
            label: 'ADDRESS',
            pointTo: {
              pointTo: 'ProfileAdress',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
            visible: true,
          },
          {
            id: '3',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005142103.png',
            name: 'Favorilerim',
            image: {},
            label: 'FAVORITES',
            pointTo: {
              pointTo: 'Favorite',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
            visible: true,
          },
          {
            id: '4',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710503824_25d36113-c2ff-4f9b-ae9f-db5c8e610671.png',
            name: 'Siparişler',
            image: {},
            label: 'ORDERS',
            pointTo: {
              pointTo: 'ProfileOrders',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
            visible: true,
          },
          {
            id: '5',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710503561_c45a5c68-934a-44c3-a080-91b85ad4878e.png',
            name: 'Dil',
            image: {},
            label: 'LANGUAGE',
            pointTo: {
              pointTo: 'ProfileLanguage',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
            visible: true,
          },
          {
            id: '6',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710503752_81b5748b-4da6-4316-94c1-bb31a21d4dd2.png',
            name: 'Sözleşmeler',
            image: {},
            label: 'POLICIES',
            pointTo: {
              pointTo: 'ProfilePrivacyPolicy',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
            visible: true,
          },
        ],
      },
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/profile_2.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'Profile_4',
      name: 'Profile_4',
      type: 'Profile',
      data: {
        text: '',
        images: [],
      },
      customization: {
        textAlignment: 'left',
        textSize: '12px',
        textColor: '#7059ef',
        textStyle: 'normal',
        textWeight: '400',
        backgroundColor: '#F0EEFB',
        textLetterSpacing: '4px',
        dangerColor: '#ff275f',
        itemColor: '#000000',
        logoutIcon: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706004973755.png',
        deleteIcon: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710503140_fb7aba20-9c96-4656-9e06-cb9699f56939.png',
        items: [
          {
            id: '1',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706004697300.png',
            name: 'Hesap Ayarları',
            image: {},
            label: 'ACCOUNT_SETTINGS',
            pointTo: {
              pointTo: 'ProfileSettings',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
            visible: true,
          },
          {
            id: '2',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710503543_c410acf5-8d8a-4656-9347-85c184c99030.png',
            name: 'Adreslerim',
            image: {},
            label: 'ADDRESS',
            pointTo: {
              pointTo: 'ProfileAdress',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
            visible: true,
          },
          {
            id: '3',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005142103.png',
            name: 'Favorilerim',
            image: {},
            label: 'FAVORITES',
            pointTo: {
              pointTo: 'Favorite',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
            visible: true,
          },
          {
            id: '4',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710503824_25d36113-c2ff-4f9b-ae9f-db5c8e610671.png',
            name: 'Siparişler',
            image: {},
            label: 'ORDERS',
            pointTo: {
              pointTo: 'ProfileOrders',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
            visible: true,
          },
          {
            id: '5',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710503561_c45a5c68-934a-44c3-a080-91b85ad4878e.png',
            name: 'Dil',
            image: {},
            label: 'LANGUAGE',
            pointTo: {
              pointTo: 'ProfileLanguage',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
            visible: true,
          },
          {
            id: '6',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710503752_81b5748b-4da6-4316-94c1-bb31a21d4dd2.png',
            name: 'Sözleşmeler',
            image: {},
            label: 'POLICIES',
            pointTo: {
              pointTo: 'ProfilePrivacyPolicy',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
            visible: true,
          },
        ],
      },
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/profile_3.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'Profile_5',
      name: 'Profile_5',
      type: 'Profile',
      data: {
        text: '',
        images: [],
      },
      customization: {
        textAlignment: 'left',
        textSize: '12px',
        textColor: '#7059ef',
        textStyle: 'normal',
        textWeight: '400',
        backgroundColor: '#F0EEFB',
        textLetterSpacing: '4px',
        dangerColor: '#ff275f',
        itemColor: '#000000',
        logoutIcon: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706004973755.png',
        deleteIcon: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710503140_fb7aba20-9c96-4656-9e06-cb9699f56939.png',
        items: [
          {
            id: '1',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706004697300.png',
            name: 'Hesap Ayarları',
            image: {},
            label: 'ACCOUNT_SETTINGS',
            pointTo: {
              pointTo: 'ProfileSettings',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
            visible: true,
          },
          {
            id: '2',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710503543_c410acf5-8d8a-4656-9347-85c184c99030.png',
            name: 'Adreslerim',
            image: {},
            label: 'ADDRESS',
            pointTo: {
              pointTo: 'ProfileAdress',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
            visible: true,
          },
          {
            id: '3',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005142103.png',
            name: 'Favorilerim',
            image: {},
            label: 'FAVORITES',
            pointTo: {
              pointTo: 'Favorite',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
            visible: true,
          },
          {
            id: '4',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710503824_25d36113-c2ff-4f9b-ae9f-db5c8e610671.png',
            name: 'Siparişler',
            image: {},
            label: 'ORDERS',
            pointTo: {
              pointTo: 'ProfileOrders',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
            visible: true,
          },
          {
            id: '5',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710503561_c45a5c68-934a-44c3-a080-91b85ad4878e.png',
            name: 'Dil',
            image: {},
            label: 'LANGUAGE',
            pointTo: {
              pointTo: 'ProfileLanguage',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
            visible: true,
          },
          {
            id: '6',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710503752_81b5748b-4da6-4316-94c1-bb31a21d4dd2.png',
            name: 'Sözleşmeler',
            image: {},
            label: 'POLICIES',
            pointTo: {
              pointTo: 'ProfilePrivacyPolicy',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
            visible: true,
          },
        ],
      },
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/profile_4.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'Profile_6',
      name: 'Profile_6',
      type: 'Profile',
      data: {
        text: '',
        images: [],
      },
      customization: {
        textAlignment: 'left',
        textSize: '12px',
        textColor: '#7059ef',
        textStyle: 'normal',
        textWeight: '400',
        backgroundColor: '#F0EEFB',
        textLetterSpacing: '4px',
        dangerColor: '#ff275f',
        itemColor: '#000000',
        logoutIcon: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706004973755.png',
        deleteIcon: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710503140_fb7aba20-9c96-4656-9e06-cb9699f56939.png',
        items: [
          {
            id: '1',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706004697300.png',
            name: 'Hesap Ayarları',
            image: {},
            label: 'ACCOUNT_SETTINGS',
            pointTo: {
              pointTo: 'ProfileSettings',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
            visible: true,
          },
          {
            id: '2',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710503543_c410acf5-8d8a-4656-9347-85c184c99030.png',
            name: 'Adreslerim',
            image: {},
            label: 'ADDRESS',
            pointTo: {
              pointTo: 'ProfileAdress',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
            visible: true,
          },
          {
            id: '3',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005142103.png',
            name: 'Favorilerim',
            image: {},
            label: 'FAVORITES',
            pointTo: {
              pointTo: 'Favorite',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
            visible: true,
          },
          {
            id: '4',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710503824_25d36113-c2ff-4f9b-ae9f-db5c8e610671.png',
            name: 'Siparişler',
            image: {},
            label: 'ORDERS',
            pointTo: {
              pointTo: 'ProfileOrders',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
            visible: true,
          },
          {
            id: '5',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710503561_c45a5c68-934a-44c3-a080-91b85ad4878e.png',
            name: 'Dil',
            image: {},
            label: 'LANGUAGE',
            pointTo: {
              pointTo: 'ProfileLanguage',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
            visible: true,
          },
          {
            id: '6',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710503752_81b5748b-4da6-4316-94c1-bb31a21d4dd2.png',
            name: 'Sözleşmeler',
            image: {},
            label: 'POLICIES',
            pointTo: {
              pointTo: 'ProfilePrivacyPolicy',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
            visible: true,
          },
        ],
      },
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/profile_5.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'Profile_Petzzshop',
      name: 'Profile_Petzzshop',
      type: 'Profile',
      data: {},
      customization: {},
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/profile_1.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
  ],
};

export default Profile;
